export enum SharedApiUrl {
    ActiveDirectoryMe = '/active-directory/me',
}
